<script setup lang="ts">
import { onMounted, onUnmounted, ref, watch } from 'vue'

import { CPDialog } from '~/portal/components/base'
import { useAppVersion } from '~/portal/composables'
import { APP_VERSION_INITIAL_DELAY } from '~/portal/utils'

const {
	pendingVersion,
	startVersionCheck,
	stopVersionCheck,
	checkForUpdate,
	reloadApp
} = useAppVersion()

const isModalOpen = ref(false)

const updateMessage: string =
	'Eine neue Version des Portals ist verfügbar. Sie können wie gewohnt ' +
	'weiterarbeiten - aktualisieren Sie die Seite, sobald Sie gerade nichts ' +
	'bearbeiten, um zur neuesten Version zu wechseln.'

let startTimer: ReturnType<typeof setTimeout> | undefined

const onVisibilityChange = (): void => {
	if (document.visibilityState === 'visible') {
		checkForUpdate()
	}
}

const onContinueWorking = (): void => {
	isModalOpen.value = false
}

watch(pendingVersion, (version: string | null): void => {
	if (version) {
		isModalOpen.value = true
	}
})

onMounted(() => {
	startTimer = setTimeout(() => {
		startVersionCheck()
		checkForUpdate()
		document.addEventListener('visibilitychange', onVisibilityChange)
	}, APP_VERSION_INITIAL_DELAY)
})

onUnmounted(() => {
	if (startTimer) {
		clearTimeout(startTimer)
	}

	stopVersionCheck()
	document.removeEventListener('visibilitychange', onVisibilityChange)
})
</script>

<template>
	<CPDialog
		v-model="isModalOpen"
		title="Eine neue Version ist verfügbar"
		:description="updateMessage"
		:actions="{ confirm: 'Weiterarbeiten', cancel: 'Jetzt aktualisieren' }"
		@click:confirm="onContinueWorking"
		@click:cancel="reloadApp"
	/>
</template>
